import { render, staticRenderFns } from "./GeneralForm.vue?vue&type=template&id=25cff81c&scoped=true&"
import script from "./GeneralForm.vue?vue&type=script&lang=js&"
export * from "./GeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./GeneralForm.vue?vue&type=style&index=0&id=25cff81c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cff81c",
  null
  
)

export default component.exports